import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-armenia-page11',
  templateUrl: './armenia-page11.component.html',
  styleUrls: ['./armenia-page11.component.css']
})
export class ArmeniaPage11Component implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
